import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CarouselModule } from 'ngx-owl-carousel-o';




@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],

})
export class DialogComponent {

  constructor() {

  }

  carouselInitialized = false;

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    navText: [
      '<i class="fa fa-caret-left" [hidden]="carouselInitialized && owlCarouselInstance?.current() === 0" aria-hidden="true"></i>',
      '<i class="fa fa-caret-right" [hidden]="owlCarouselInstance?.current() === 1" aria-hidden="true"></i>'
    ], responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 2
      }
    },
    nav: true
  }
  @ViewChild('owlCarousel') owlCarousel: any;

  ngOnInit(): void { }
  onCarouselInitialized(event: any): void {
    this.carouselInitialized = true;
  }

  openLink() {
    var a = document.createElement('a');
    a.href = 'https://bit.ly/3RhE58g';
    a.target = '_blank'
    a.click();
  }

}